import { useEmitResourceConnectEvents as useEmitResourceConnectEventsObservability } from "@zapier/observability";
import { useAtomValue } from "jotai";
import {
  canvasAtom,
  currentAccountIdAtom,
  sessionAtom,
} from "@zapier/canvas-state";

export function useEmitResourceConnectEvents() {
  const canvas = useAtomValue(canvasAtom);
  const session = useAtomValue(sessionAtom);
  const currentAccountId = useAtomValue(currentAccountIdAtom);

  return useEmitResourceConnectEventsObservability({
    canvasId: canvas.id,
    sessionId: session?.id,
    currentAccountId: currentAccountId,
  });
}
